import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { manageDomainClick } from '../actions/manageDomainClick';
import { traceManageDomainButtonClick } from '../utils/domainOptionTracer';
var manageDomainUrl = 'https://go.microsoft.com/fwlink/?linkid=872355';
export default orchestrator(manageDomainClick, function mangeDomainClick() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            traceManageDomainButtonClick();
            window.open(manageDomainUrl, '_blank');
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=manageDomainClick.js.map